import { SkyBoxRoutesEnum } from "models/enums/apiRoutes/skyBoxApiRoutes";
import { IApiBaseResponse } from "models/interfaces/Iglobal";
import axiosClient from "sharedServices/api/axios.services";

export class CalendarPresetService {
  public getCalendarPresetData = async () => {
    return axiosClient.get<IApiBaseResponse>(
      SkyBoxRoutesEnum.CALENDAR_PRESETS
    );
  };
}
